<template>
    <div id="add-widget" class="modal inmodal fade" role="dialog" aria-hidden="true" data-backdrop="static" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content animated fadeInUp">
                <div class="modal-header-dialog-painting">
                    <h2 class="modal-title">{{ t_title + (global ? ' GLOBAL' : '') }}</h2>
                </div>
                <div class="modal-body scrollBox" :style="'max-height: ' + maxBodyHeight + 'px;'">
                    <div class="wizard-notifications">
                        <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
                            {{ t_error }}
                            <ul>
                                <li v-for="error in errors">
                                    {{ error }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <dropzone id="dz-add-widget" @uploadedFile="addUploadedFile"
                              @uploadFailed="addUploadFailed"
                              @filesToUpload="filesToUploadChanged"
                              @actionNeeded="actOnUpload"
                              @addedFiles="resetErrors"
                              :global="global">
                    </dropzone>
                    <div class="wizard-notifications">
                        <div v-if="Object.keys(actionsNeeded).length > 0">
                            <div v-for="(action, key) in actionsNeeded">
                                <div class="alert alert-success">
                                    <span>
                                        {{ action.text }}
                                    </span>
                                    <div class="row">
                                        <div class="col-md-12 ">
                                            <div class=" btn btn-primary btn-xs m-t-xs" @click="actionProceed(key, action)">
                                                {{ t_overwrite }}
                                            </div>
                                            <div class=" btn btn-xs btn-white m-t-xs" @click="actionCancel(key, action)">
                                                {{ t_cancel }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <v-btn type="button" class="btn btn-white btn-secondary" @click.stop.prevent="cancelUpload">{{ t_cancel }}
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import modalMixin from "../../common/modal-mixin";
import toaster from "../../common/toaster";

export default {
    mixins: [
        modalMixin,
    ],
    props: [
        'add',
        'backUrl',
        'insertX',
        'insertY'
    ],
    components: {
        dropzone: require('./add/dropzone.vue').default,
    },
    data: function () {
        return {
            t_title: Lang.langGet("Add new widget"),
            t_error: Lang.langGet("Failed to save widgets:"),
            t_cancel: Lang.langGet("Cancel"),
            t_save: Lang.langGet("Save"),
            t_overwrite: Lang.langGet("Overwrite"),
            t_add_success: Lang.langGet("Widget added successfully."),
            t_cancel_fail: Lang.langGet("Widget upload could not be cancelled."),
            t_add_fail: Lang.langGet("Widget upload failed."),
            strict_mode: false,
            errors: {},
            actionsNeeded: {},
            saving: false,
            modalName: 'add-widget',
            filesToUpload: 0,
            filesUploaded: 0,
            global: 0,
        }
    },
    methods: {
        reset: function () {
            this.actionsNeeded = {};
            this.errors = {};
            this.filesToUpload = 0;
            this.filesUploaded = 0;
        },
        resetErrors: function () {
            this.errors = {};
        },
        addUploadedFile: function (file) {
            this.filesUploaded++;
            EaseEventBus.fire('updateWidgetlist');
        },
        addUploadFailed: function (error) {
            this.errors = _.extend({}, this.errors, error);
        },
        actOnUpload: function (information) {
            this.actionsNeeded = _.extend({}, this.actionsNeeded, information);
        },
        cancelUpload: function () {
            EaseEventBus.fire('cancelUpload');
            EaseEventBus.fire('hideModal', 'add-widget');

            if (this.add === '1') {
                window.location = this.backUrl;
            }
        },
        filesToUploadChanged(count) {
            this.filesToUpload = count;

            if (Object.keys(this.actionsNeeded).length === 0 && this.filesToUpload === 0 && this.filesUploaded > 0) {
                EaseEventBus.fire('hideModal', 'add-widget');
            }
        },
        actionProceed: function (key, action) {
            axios.post('/administration/widget/upload/proceed', {
                project_id: Laravel.activeProject,
                data: action.back_data,
                file_name: key,
                global: this.global,
            }).then((data) => {
                toaster.success(this.t_add_success);
                let actionsNeeded = this.actionsNeeded;
                delete actionsNeeded[key];
                this.actionsNeeded = _.extend({}, this.actionsNeeded, actionsNeeded);

                this.handleUpload(data.data);
                this.filesToUploadChanged(this.filesToUpload);
            }).catch((error) => {
                if (error.response.status === 401) {
                    window.location = '/login';
                }

                this.errors = _.extend({}, this.errors, [error.response.data.error]);
                toaster.error(this.t_add_fail);
            });
        },
        actionCancel: function (key, action) {
            axios.post('/administration/widget/upload/cancel', {
                project_id: Laravel.activeProject,
                data: action.back_data,
                file_name: key,
                global: this.global,
            }).then((data) => {
                let actionsNeeded = this.actionsNeeded;
                delete actionsNeeded[key];
                this.actionsNeeded = _.extend({}, this.actionsNeeded, actionsNeeded);
                this.handleUpload(data.data);
                this.filesToUploadChanged(this.filesToUpload);
            }).catch((error) => {
                if (error.response.status === 401) {
                    window.location = '/login';
                }

                this.errors = _.extend({}, this.errors, [error.response.data.error]);
                toaster.error(this.t_cancel_fail);
            });
        },
        handleUpload: function (json) {
            if(json.element) {
                this.addUploadedFile(json.element);
            } else if (json.error) {
                this.addUploadFailed(json.element);
            } else if (json.information) {
                this.actOnUpload(json.information);
            }
        }
    },
    mounted() {
        EaseEventBus.listen('showAddWidgetModal', (global) => {
            this.global = global;
            this.reset();
            $(this.$el).find(this.animateElements).addClass('animated');
            EaseEventBus.fire('showModal', this.modalName);
        });
    }
}
</script>
